import DialogTitle from "@mui/material/DialogTitle";

export default DialogTitle;
